// eslint-disable-next-line no-unused-vars

import { createStore } from 'vuex'

import * as getters from './getters'
import mutations from './mutations'
import actions from './actions'


import auth from './modules/auth/index'
import countries from './modules/settings/countries'
import cities from './modules/settings/cities'
import brands from './modules/settings/brands'
import taxes from './modules/settings/taxes'
import payments from './modules/settings/payments'
import currencies from './modules/settings/currencies'
import variations from './modules/settings/variations'
import productOptions from './modules/settings/productOptions'
import role from './modules/role'
import user from './modules/user'
import permission from './modules/permission'
import categories from './modules/settings/categories'
import products from './modules/products'
import attributs from './modules/settings/attributs'
import contacts from './modules/contacts'
import store from './modules/store'
import shop from './modules/shop'
import boxes from './modules/boxes'
import license from './modules/license'
import lots from './modules/settings/lots'
import bundle from './modules/bundle'
import promotion from './modules/promotion'
import loyalty from './modules/loyalty'
import society from './modules/society'
import core from './modules/core'
import codePromo from './modules/codePromo'
import area from './modules/settings/areas'
import interval from './modules/settings/intervals'
import measure from './modules/settings/measures'
import relay from './modules/settings/relay'
import media from './modules/settings/media'
import review from './modules/review'
import fees from './modules/settings/fees'
import orders from './modules/supplier/orders'
import ecommerce from './modules/ecommerce'
import session from './modules/session'
import recaptcha from './modules/settings/recaptcha'
import landlordAuth from './modules/landlordAuth/index'
import landlord from './modules/landlord/index'
import tenantModule from './modules/tenantModule'
import posCart from './modules/posCart'
import posCategories from './modules/posCategories'
import posContact from './modules/posContact'

const initialState = {
  isAppLoaded: false
}

export default createStore({
  // strict: true,
  state: initialState,

  getters,
  mutations,
  actions,

  modules: {
    auth,
    countries,
    landlordAuth,
    cities,
    brands,
    taxes,
    payments,
    variations,
    role,
    user,
    permission,
    categories,
    products,
    attributs,
    contacts,
    store,
    shop,
    boxes,
    currencies,
    license,
    lots,
    bundle,
    codePromo,
    promotion,
    loyalty,
    society,
    core,
    area,
    interval,
    measure,
    relay,
    review,
    fees,
    orders,
    ecommerce,
    media,
    session,
    recaptcha,
    landlord,
    tenantModule,
    posCart,
    posCategories,
    posContact,
    productOptions,
  }
})
